import { render } from "./DeletedExtraServices.vue?vue&type=template&id=5501378a&scoped=true"
import script from "./DeletedExtraServices.vue?vue&type=script&lang=js"
export * from "./DeletedExtraServices.vue?vue&type=script&lang=js"

import "./DeletedExtraServices.vue?vue&type=style&index=0&id=5501378a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5501378a"]])

export default __exports__